export const mustHave = {
  validate: (value, params) => params.every(v => value.includes(v)),
  message: (field, params) => {
    const args = Object.keys(params).filter(key => !isNaN(key)).map(key => params[key]).join(', ');
    return `El campo ${field} debe tener minimo las opciones: ${args}`;
  },
}
